import React, { useState, useContext, useEffect } from "react";
import './language.scss';
import { ReactComponent as EnglishFlag} from '../../Assets/Svg/gb.svg';
import { ReactComponent as PolishFlag} from '../../Assets/Svg/pl.svg';
import LanguageContext from "../../Contexts/Language";
import English from '../../Languages/english.json';
import Polish from '../../Languages/polish.json';

const Language = () =>{
    const [currentLanguage, setCurrentLanguage] = useState(localStorage.getItem("language") || "english");
    const [canChange, setCanChange] = useState(true);
    const {setLanguage} = useContext(LanguageContext);
    const [isLoaded, setIsLoaded] = useState(false);

    const changeLanguage = () =>{
        if(canChange){
            setCurrentLanguage(currentLanguage === "english" ? "polish" : "english")
            localStorage.setItem("language",currentLanguage === "english" ? "polish" : "english");
            setLanguage(currentLanguage === "english" ? Polish : English)
            setCanChange(false)
            setTimeout(() =>{
                setCanChange(true)
            },1000)
        }
    }

    useEffect(() =>{    
        if(!localStorage.getItem("language")){
            localStorage.setItem("language","english");
        }
    },[])

    useEffect(() =>{
        setTimeout(() =>{
            setIsLoaded(true)
        },1000)
    },[])

    return(
        <div className={`language is-english-${currentLanguage === "english" ? "true" : "false"}`} onClick={changeLanguage}>
            <div className="english" style={{animationDuration: isLoaded ? "1s" : "0s"}}>
                <EnglishFlag/>
            </div>
            <div className="polish" style={{animationDuration: isLoaded ? "1s" : "0s"}}>
                <PolishFlag/>
            </div>
        </div>
    )
}
export default Language